import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import {
  ReaMetricItem,
  ReaTechnicalDetailItem,
} from 'src/app/models/fincas/rea.model';

/**
 * Displays support-only information behind a collapsed details block.
 */
@Component({
  selector: 'app-rea-import-technical-details',
  templateUrl: './rea-import-technical-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ReaImportTechnicalDetailsComponent {
  @Input()
  public title = 'Detalles técnicos para soporte';

  @Input()
  public details: ReaTechnicalDetailItem[] = [];

  @Input()
  public metrics: ReaMetricItem[] = [];

  public get hasContent(): boolean {
    return this.details.length > 0 || this.visibleMetrics.length > 0;
  }

  public get visibleMetrics(): ReaMetricItem[] {
    return this.metrics.filter((metric) => metric.visible);
  }
}
